// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "1 Paralipomenon (1 Chronicles)",
  bookSlug: "1-paralipomenon",
  chapter: 14,
  argument: "David's house, and children; his victories over the Philistines.",
  verses: [
    { n: 1, text: "And Hiram, king of Tyre, sent messengers to David; and cedar-trees, and masons, and carpenters, to build him a house." },
    { n: 2, text: "And David perceived that the Lord had confirmed him king over Israel, and that his kingdom was exalted over his people, Israel." },
    { n: 3, text: "And David took other wives in Jerusalem: and he begot sons, and daughters." },
    { n: 4, text: "Now these are the names of them that were born to him in Jerusalem: Samua, and Sobad, Nathan, and Solomon," },
    { n: 5, text: "Jebahar, and Elisua, and Eliphalet," },
    { n: 6, text: "And Noga, and Napheg, and Japhia," },
    { n: 7, text: "Elisama, and Baaliada, and Eliphalet." },
    { n: 8, text: "And the Philistines hearing that David was anointed king over all Israel, went all up to seek him: and David heard of it, and went out against them." },
    { n: 9, text: "And the Philistines came and spread themselves in the vale of Raphaim." },
    { n: 10, text: "And David consulted the Lord, saying: Shall I go up against the Philistines, and wilt thou deliver them into my hand? And the Lord said to him: Go up, and I will deliver them into thy hand." },
    { n: 11, text: "And when they were come to Baalpharasim, David defeated them there, and he said: God hath divided my enemies by my hand, as waters are divided: and therefore the name of that place was called Baalpharasim." },
    { n: 12, text: "And they left there their gods, and David commanded that they should be burnt." },
    { n: 13, text: "Another time also the Philistines made an irruption, and spread themselves abroad in the valley." },
    { n: 14, text: "And David consulted God again, and God said to him: Go not up after them, turn away from them, and come upon them over-against the pear-trees." },
    { n: 15, text: "And when thou shalt hear the sound of one going in the tops of the pear-trees, then shalt thou go out to battle. For God is gone out before thee, to strike the army of the Philistines." },
    { n: 16, text: "And David did as God had commanded him, and defeated the army of the Philistines, slaying them from Gabaon to Gazera." },
    { n: 17, text: "And the name of David became famous in all countries, and the Lord made all nations fear him." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Hiram. This embassy, and the war with the Philistines, took place before the ark was removed.", attribution: "Calmet" }
    ] },
    { verse: 2, notes: [
      { text: "Perceived, by divine revelation, or by his constant success, (Menochius) as well as by the presents of \"the king of Tyre, and the unanimity\" of all the people. (Du Hamel) — Over his. Hebrew and Septuagint, on account of his people. Kings are more for their subjects than for themselves.", attribution: "Calmet" }
    ] },
    { verse: 5, notes: [
      { text: "Eliphalet and Noga are not mentioned, 2 Kings v. 15. (Calmet) See chap iii. 9.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Baaliada, probably the same with Eliada.", attribution: "Calmet" }
    ] },
    { verse: 8, notes: [
      { text: "Seek him, with a design to oppress him, before his throne was established.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Baalpharasim, \"the god or master of divisions.\" (Calmet) — The place was so called afterwards.", attribution: "Du Hamel" }
    ] },
    { verse: 12, notes: [
      { text: "Burnt, conformably to Deuteronomy vii. 25. These idols were commonly made of wood, and covered with plates of gold, &c. The Philistines took them along with them to battle, as the Hebrews carried the ark on many occasions. The Greeks, at the siege of Troy, had their gods on board their vessels; (Homer, Iliad ix.) and the Romans had theirs on their ensigns, in their wars.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Pear or mulberry trees, (2 Kings v. 23.; Calmet) on the side where the idols were.", attribution: "Tirinus" }
    ] },
    { verse: 15, notes: [
      { text: "Tops, or on the height. God sent an invisible army to David's assistance.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Gazera, on the borders of the Philistines, near Azotus.", attribution: "Calmet" }
    ] },
    { verse: 17, notes: [
      { text: "All countries and nations, in the vicinity.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
